// Local translations
export const T = {
  en_GB: {
    deleteComponent: "Delete component",
    deleteTabsBlock: "Delete tabs block",
    settings: "Settings",
    edit: "Edit",
    tabsBlock: "Tabs Block",
    conditional: "Conditional",
    desc: "Desc",
    addComponent: "Add Component",
    addTab: "Add Tab",
    deleteTab: "Delete Tab",
    tabSettings: "Tab Settings",
    dropComponentHere: "Drop component here",
    noComponents: "No components",
    required: "Required",
    movingComponent: "Moving component...",
    costProjectionChart: "Cost Projection Chart",
    duplicateComponent: "Duplicate component",
  },
  nb_NO: {
    deleteComponent: "Slett komponent",
    deleteTabsBlock: "Slett faneblokk",
    settings: "Innstillinger",
    edit: "Rediger",
    tabsBlock: "Faneblokk",
    conditional: "Betinget",
    desc: "Besk",
    addComponent: "Legg til komponent",
    addTab: "Legg til fane",
    deleteTab: "Slett fane",
    tabSettings: "Faneinnstillinger",
    dropComponentHere: "Slipp komponent her",
    noComponents: "Ingen komponenter",
    required: "Påkrevd",
    movingComponent: "Flytter komponent...",
    costProjectionChart: "Kostnadsframskrivning",
    duplicateComponent: "Dupliser komponent",
  },
} as const;
